const purchaseType = {
    1: 'For Sale',
    2: 'For Rent'
};
const strategy = {
    'sold-date': {
        name: 'soldDate',
        transform(value) {
            return normalize(value * 24 * 3600 * 1000, 'inputBox', 'date');
        }
    },
    'purchaseType-For-Sale-Rent': {
        name: 'purchaseType',
        transform(value) {
            return normalize(purchaseType[value] || '', 'singleSelect');
        }
    },
    'More-Than-Beds': {
        name: 'beds',
        transform(value) {
            return normalize(value, 'inputBox');
        }
    },
    'listingStatus-multi-Back-on-Market': {
        name: 'listingStatus',
        transform(value) {
            return normalize(value, 'multiSelect');
        }
    },
    'hasOpenHouse-1-listingStatus-Active': {
        name: 'openHouse',
        transform() {
            return true;
        }
    },
    'hasPriceChanged-3': {
        name: 'priceReduced',
        transform() {
            return true;
        }
    },
    'VirtualTour-Flag': {
        name: 'virtualTour',
        transform() {
            return true;
        }
    },
    '3DTour-Flag': {
        name: '3DTour',
        transform() {
            return true;
        }
    },
    'minPrice-maxPrice': {
        name: 'price',
        transform(value) {
            return normalize(value, 'inputBox');
        }
    },
    key: {
        name: 'location',
        transform(key, keywordType) {
            const location = {};
            const keyArr = key.split(';');
            const typeArr = keywordType.split(';');
            keyArr.forEach((key, index) => {
                !location[typeArr[index]] && (location[typeArr[index]] = []);
                location[typeArr[index]].push(key);
            });
            return location;
        }
    }
};

function normalize(value, inputType, mask) {
    switch (inputType) {
        case 'inputBox':
            return transformInputBox(value, mask);
        case 'singleSelect':
        case 'multiSelect':
            return transformSelect(value);
        default:
            return '';
    }
}
function transformInputBox(value, mask) {
    switch (mask) {
        case 'date':
            let [v1, v2] = (value + '').split(',');
            v1 && (v1 = Date.now() - Number(v1));
            v2 && (v2 = Date.now() - Number(v2));
            return `${v1 ? v1 : ''},${v2 ? v2 : ''}`;
        default:
            return value;
    }
}
function transformSelect(value) {
    return value.split(',');
}

export function normalizeParams(isSearchCenter, merge, base = {}, opts = {}) {
    if (isSearchCenter) {
        let normalized = {};
        Object.keys(merge).forEach((kee) => {
            if (kee === 'keywordType') return;
            if (kee === 'key') {
                const { name, transform } = strategy[kee];
                normalized[name] = transform(merge[kee], merge.keywordType);
            } else if (kee === 'selected') {
                merge[kee].split(',').forEach((item) => {
                    const { name, transform } = strategy[item] || {};
                    normalized[name] = transform();
                });
            } else {
                const { name, transform } = strategy[kee] || {};
                if (name) {
                    normalized[name] = transform(merge[kee]);
                } else {
                    normalized[kee] = merge[kee];
                }
            }
        });
        if (opts.needKey) {
            return { condition: JSON.stringify({ ...base, ...normalized }) };
        }
        return { ...base, ...normalize };
    } else {
        return { ...base, ...merge };
    }
}
